import React, { useState, useEffect } from 'react'
import { useLocation } from "react-router-dom";
import { Container, Card, Row, Col, Form, Button } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';



import axios from "axios";

const AddBuses = () => {
  const userData = sessionStorage.getItem('user');
  const userObj = userData ? JSON.parse(userData) : {};
  const [editId, setEditId] = useState(null);
  const [levels, setlevels] = useState([]);
  const [removedDocIds, setRemovedDocIds] = useState([]);
  // const [drivers, setDrivers] = useState([]);
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const [documents, setDocuments] = useState([]);
  const routeLocation = useLocation();
  const [form, setForm] = useState({
    vehicle_id: "",
    model: "",
    last_service_date: "",
    status: "A",
    school_id: "",
  });

  useEffect(() => {
    if (routeLocation.state?.busesData) {
      const busesData = routeLocation.state.busesData;
      setForm(busesData);
      setEditId(busesData.vehicle_id);

      // ✅ Populate documents if they exist
      if (busesData.documents && Array.isArray(busesData.documents)) {
        setDocuments(
          busesData.documents.map((doc) => ({
            vehicle_document_id: doc.vehicle_document_id || null,
            document_name: doc.document_name || "",
            document_number: doc.document_number || "",
            // keep attachment as string (URL), user may replace later
            attachment: doc.attachment || null,
          }))
        );
      }
    }
  }, [routeLocation]);



  const handleDocumentChange = (index, e) => {
    const { name, value, files } = e.target;
    setDocuments((prevDocs) => {
      const updatedDocs = [...prevDocs];
      updatedDocs[index] = {
        ...updatedDocs[index],
        [name]: name === "attachment" ? files[0] : value
      };
      return updatedDocs;
    });
  };

  const addDocument = () => {
    setDocuments((prev) => [...prev, { document_name: "", document_number: "", attachment: null }]);
  };

  const removeDocument = (index) => {
  setDocuments((prev) => {
    const doc = prev[index];
    if (doc?.vehicle_document_id) {
      setRemovedDocIds((ids) => [...ids, doc.vehicle_document_id]);
    }
    return prev.filter((_, i) => i !== index);
  });
};


  const handleRemoveAttachment = (index) => {
    setDocuments((prevDocs) => {
      const updatedDocs = [...prevDocs];
      updatedDocs[index] = {
        ...updatedDocs[index],
        attachment: null,   // remove the file
      };
      return updatedDocs;
    });
  };



  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setForm((prevForm) => ({
      ...prevForm,
      [id]: value
    }));
  };

  const uploadFiles = async () => {
    const formData = new FormData();

    documents.forEach((doc) => {
      if (doc.attachment instanceof File) {
        formData.append("files", doc.attachment);
      }
    });

    // ✅ If no files, return empty array instead of hitting API
    if (!formData.has("files")) {
      return [];
    }

    const res = await axios.post(`${baseUrl}/uploads/multipleupload/`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data.uploaded_files;
  };



  const mapDocumentsWithAttachments = (uploadedFiles) => {
    let uploadIndex = 0;

    return documents.map((doc) => {
      // If this document had a new file, assign from uploadedFiles
      if (doc.attachment instanceof File) {
        const uploadedFile = uploadedFiles[uploadIndex];
        uploadIndex++;
        return {
          vehicle_document_id: doc.vehicle_document_id || null,
          document_name: doc.document_name,
          document_number: doc.document_number,
          attachment: uploadedFile?.location || null,
        };
      }

      // Otherwise, keep the existing attachment as-is
      return {
        vehicle_document_id: doc.vehicle_document_id || null,
        document_name: doc.document_name,
        document_number: doc.document_number,
        attachment: doc.attachment || null,
      };
    });
  };



 const handleSubmit = async (e) => {
  e.preventDefault();
  try {
    let documentsWithAttachments = [];

    if (documents.length > 0) {
      const uploadedFiles = await uploadFiles();
      documentsWithAttachments = mapDocumentsWithAttachments(uploadedFiles);
    }

    // ✅ remove deleted docs from payload (don’t send them)
    const removedSet = new Set(removedDocIds);
    documentsWithAttachments = documentsWithAttachments.filter(
      (d) => !(d?.vehicle_document_id && removedSet.has(d.vehicle_document_id))
    );

    const payload = {
      vehicle_id: editId || 0,
      model: form.model,
      last_service_date: form.last_service_date || null,
      status: "A",
      created_by: userObj.userid || "",
      updated_by: userObj.userid || "",
      school_id: userObj.school_id,
      documents: documentsWithAttachments,
      deleted_documents: removedDocIds,
      action: editId !== null ? "UPDATE" : "CREATE",
    };

    await axios.post(`${baseUrl}/vehicle/`, payload, {
      headers: { "Content-Type": "application/json" },
    });

    toast.success(editId ? "Record Updated Successfully" : "Record Added Successfully");
    setEditId(null);
    setForm({ vehicle_id: "", model: "", last_service_date: "" });
    setDocuments([]);
    setRemovedDocIds([]); // ✅ reset
  } catch (err) {
    console.error("Error submitting:", err);
    toast.error("Error submitting data");
  }
};



  return (

    <div className='pageBody'>
      <ToastContainer />
      <Container fluid>
        <Card>
          <Card.Body>
            <div style={{
              maxHeight: '80vh',
              overflowY: 'auto',
              paddingRight: '10px'
            }}>
              <form onSubmit={handleSubmit}>
                <Row>
                  <Col xs={12}>
                    <h6 className='commonSectionTitle'>Vehicle Details</h6>
                  </Col>

                </Row>
                <Row>



                  <Col xs={12} md={6} lg={4} xxl={3}>
                    <div className='commonInput'>
                      <Form.Group>
                        <Form.Label>
                          Model <span className='requiredStar'>*</span>
                        </Form.Label>
                        <Form.Control
                          required
                          type="text"
                          id="model"
                          value={form.model}
                          placeholder="Enter Model"
                          maxLength={50}
                          onChange={handleInputChange}
                          onKeyDown={(e) => {
                            if (e.key === ' ' && e.target.selectionStart === 0) {
                              e.preventDefault();
                            }
                          }}
                        />

                      </Form.Group>
                    </div>
                  </Col>

                  <Col xs={12} md={8} lg={6} xxl={4}>
                    <div className="d-flex align-items-end">
                      <div className="commonInput flex-grow-1 me-2">
                        <Form.Group>
                          <Form.Label>
                            Last Service Date <span className="requiredStar">*</span>
                          </Form.Label>
                          <Form.Control
                            type="date"
                            id="last_service_date"
                            value={form.last_service_date || ""}
                            onChange={handleInputChange}
                            required
                          />
                        </Form.Group>
                      </div>
                      <Button
                        variant="outline-primary"
                        style={{ height: "fit-content", whiteSpace: "nowrap", marginBottom: "4%", marginLeft: "5%" }}
                        onClick={addDocument}
                      >
                        + Upload Document
                      </Button>
                    </div>
                  </Col>

                  {documents.map((doc, index) => (
                    <Row key={index} className="mt-3">

                      <Col xs={12} md={6} lg={4} xxl={3}>
                        <div className='commonInput'>
                          <Form.Group>
                            <Form.Label>
                              Document Name
                            </Form.Label>
                            <Form.Control

                              type="text"
                              name="document_name"
                              maxlength={50}
                              value={doc.document_name}
                              placeholder="Enter Document Name"
                              onChange={(e) => handleDocumentChange(index, e)}
                              onKeyDown={(e) => {
                                if (e.key === ' ' && e.target.selectionStart === 0) {
                                  e.preventDefault();
                                }
                              }}
                            />
                          </Form.Group>
                        </div>
                      </Col>

                      <Col xs={12} md={6} lg={4} xxl={3}>
                        <div className='commonInput'>
                          <Form.Group>
                            <Form.Label>
                              Document Number
                            </Form.Label>
                            <Form.Control

                              type="text"
                              name="document_number"
                              value={doc.document_number}
                              placeholder="Enter Document Number"
                              maxlength={50}
                              onChange={(e) => handleDocumentChange(index, e)}
                              onKeyDown={(e) => {
                                if (e.key === ' ' && e.target.selectionStart === 0) {
                                  e.preventDefault();
                                }
                              }}
                            />
                          </Form.Group>
                        </div>
                      </Col>

                      <Col xs={12} md={6} lg={4} xxl={3}>
                        <div className="commonInput">
                          <Form.Group>
                            <Form.Label>Attachment</Form.Label>

                            {/* ✅ Always show file input */}
                            <Form.Control
                              type="file"
                              name="attachment"
                              onChange={(e) => handleDocumentChange(index, e)}
                            />

                            {/* ✅ If there’s already a saved file from DB, show hyperlink */}
                            {doc.attachment && typeof doc.attachment === "string" && (
                              <div className="d-flex align-items-center mt-2">
                                <a
                                  href={`${baseUrl}/uploads/get-image/${encodeURIComponent(
                                    doc.attachment.replace(/^uploads[\\/]/, "")
                                  )}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  download={doc.attachment.split(/[\\/]/).pop()}
                                  style={{
                                    textDecoration: "none",
                                    color: "#007bff",
                                    wordBreak: "break-all",
                                  }}
                                >
                                  {doc.attachment.split(/[\\/]/).pop()}
                                </a>
                                <Button
                                  variant="danger"
                                  size="sm"
                                  className="ms-2"
                                  onClick={() => handleRemoveAttachment(index)}
                                >
                                  X
                                </Button>
                              </div>
                            )}

                            {/* ✅ If a new file was just uploaded, show its name */}
                            {doc.attachment instanceof File && (
                              <div className="d-flex align-items-center mt-2">
                                <span className="me-2">{doc.attachment.name}</span>
                                <Button
                                  variant="danger"
                                  size="sm"
                                  onClick={() => handleRemoveAttachment(index)}
                                >
                                  X
                                </Button>
                              </div>
                            )}
                          </Form.Group>
                        </div>
                      </Col>



                      <Col xs={12} md={1} className="d-flex align-items-center justify-content-center">
                        <span
                          style={{ cursor: "pointer", fontSize: "24px", color: "red", fontWeight: "bold", lineHeight: "1" }}
                          onClick={() => removeDocument(index)}
                          title="Remove"
                        >
                          –
                        </span>
                      </Col>


                    </Row>
                  ))}



                </Row>
                <div className="d-flex justify-content-between mt-3">
                  <div>
                    <Button
                      type="button"
                      variant="primary"
                      className="btn-info clearBtn"
                      onClick={() => {
                        setForm({
                          vehicle_id: "",
                          model: "",
                          last_service_date: "",
                          status: "A",
                          school_id: userObj?.school_id || "",
                        });
                        setDocuments([]);
                        setEditId(null);
                        // toast.info("Form cleared");
                      }}
                    >
                      Reset
                    </Button>

                  </div>
                  <div>
                    <Button
                      type="button"
                      variant="primary"
                      className="btn-danger secondaryBtn me-2"
                      onClick={() => window.history.back()}
                    >
                      Cancel
                    </Button>
                    <Button
                      type="submit"
                      variant="primary"
                      className="btn-success primaryBtn"
                    >
                      Submit
                    </Button>
                  </div>
                </div>
              </form>
            </div>
          </Card.Body>
        </Card>
      </Container>

    </div>

  );
};

export default AddBuses;